import '@/app/app.css';
import './main.css';

import '@/app/app';

import { CategoryCards } from '@/components/card/card-category/category-cards';
import { VideoSwitcher } from '@/shared/common/video/video-switcher';

document.addEventListener('DOMContentLoaded', () => {
	const categoryCards = document.querySelector('.js-category-cards');
	categoryCards && new CategoryCards(categoryCards);

	document.querySelectorAll('.js-video-switcher').forEach((element) => {
		new VideoSwitcher(element);
	});
});
